<template>
  <div class="rc-address-runtime" :class="{getClassByCopy,'to-left':component.properties.sortType==='toLeft','to-top':component.properties.sortType==='toTop','hidden':component.properties.sortType==='hidden'}">
    <el-form-item class="form-item-label" :label="labelParameter.labelName" :title="component.name" :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
    </el-form-item>
      <el-form-item :prop="getProp" :rules="provinceRule" class="form-item-address" :title="component.name">
        <el-select class="form-select-address" placeholder="请选择省份" v-model="editRunServiceData.province" @change="changeProvince" filterable clearable>
          <el-option v-for="province in addressData"
                     :value="province.name"
                     :key="province.name"
                     :label="province.name"
                     :class="getClassByCopy"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :prop="component.archive.columnId" :rules="cityRule" class="form-item-address">
        <el-select class="form-select-address" placeholder="请选择城市" v-model="editRunServiceData.city" @change="changeCity" filterable clearable>
          <el-option v-for="city in cityList"
                     :value="city.name"
                     :key="city.name"
                     :label="city.name"
                     :class="getClassByCopy"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :prop="component.archive.columnId" :rules="areaRule" class="form-item-address">
        <el-select class="form-select-address" placeholder="请选择区" v-model="editRunServiceData.area" @change="changeArea" filterable clearable>
          <el-option v-for="(area,index) in areaList"
                     :value="area"
                     :key="index"
                     :label="area"
                     :class="getClassByCopy"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :class="getClassByCopy" :prop="component.archive.columnId" :rules="addressRule" class="form-item-address">
        <el-input class="form-input" placeholder="请输入详细地址" v-model="editRunServiceData.detailAddress" @change="changeArea"></el-input>
      </el-form-item>
  </div>
</template>

<script>
import { componentMixin, inputMixin } from './mixins'
import { addressList } from '../../../../assets/js/address-china'
export default {
  name: 'rc-address',
  mixins: [ componentMixin, inputMixin ],
  props: ['component', 'value', 'index', 'labelParameter'],
  inject: ['initCount', 'initState'],
  data () {
    return {
      editRunServiceData: {
        province: '',
        city: '',
        area: '',
        detailAddress: ''
      },
      // 省市区所有数据
      addressData: addressList,
      // 必填校验需要解析数据模型，要写在自定义方法里面
      provinceRule: [{validator: this.provinceCheck, requiredOption: this.component.properties.addressRequired, trigger: 'change'}],
      cityRule: [{validator: this.cityCheck, requiredOption: this.component.properties.addressRequired, trigger: 'change'}],
      areaRule: [{validator: this.areaCheck, requiredOption: this.component.properties.addressRequired, trigger: 'change'}],
      addressRule: [{validator: this.addressCheck, requiredOption: this.component.properties.addressRequired, trigger: 'blur'}]
    }
  },
  created () {
    if (this.component.properties.sortType === '') {
      this.component.properties.sortType = 'toLeft'
    }
  },
  methods: {
    // 表单加载完，初始化控件属性
    init () {
      // 如果传过来value有值，则需要进行初始化操作
      if (this.value) {
        this.initData()
      }
    },
    // 改变省份
    changeProvince () {
      this.editRunServiceData.city = ''
      this.editRunServiceData.area = ''
      this.updateData()
    },
    // 改变城市
    changeCity () {
      this.editRunServiceData.area = ''
      this.updateData()
    },
    // 改变地区或详细地址
    changeArea () {
      this.updateData()
    },
    // 构造数据模型走更新
    updateData () {
      let dataModel = this.editRunServiceData.province + ' ' + this.editRunServiceData.city + ' ' + this.editRunServiceData.area + ' ' + this.editRunServiceData.detailAddress
      this.update(dataModel)
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    },
    // 编辑的时候初始化数据
    initData () {
      if (this.value) {
        let dataModelArr = this.value.split(' ')
        this.editRunServiceData.province = dataModelArr[0] || ''
        this.editRunServiceData.city = dataModelArr[1] || ''
        this.editRunServiceData.area = dataModelArr[2] || ''
        this.editRunServiceData.detailAddress = dataModelArr[3] || ''
      }
    },
    // 解析数据
    analyData (value) {
      let addressArr = value ? value.split(' ') : ['', '', '', '']
      if (addressArr.length === 1 || addressArr === undefined) {
        addressArr = ['', '', '', '']
      }
      return addressArr
    },
    // 省份校验
    provinceCheck (rule, value, callback) {
      let addressArr = this.analyData(value)
      if (rule.requiredOption.province && addressArr[0] === '') {
        callback(new Error(`省份必填`))
      } else {
        callback()
      }
    },
    // 城市校验
    cityCheck (rule, value, callback) {
      let addressArr = this.analyData(value)
      if (rule.requiredOption.city && addressArr[1] === '') {
        callback(new Error(`城市必填`))
      } else {
        callback()
      }
    },
    // 区域校验
    areaCheck (rule, value, callback) {
      let addressArr = this.analyData(value)
      if (rule.requiredOption.area && addressArr[2] === '') {
        callback(new Error(`区域必填`))
      } else {
        callback()
      }
    },
    // 详细地址校验
    addressCheck (rule, value, callback) {
      let addressArr = this.analyData(value)
      if (rule.requiredOption.address && addressArr[3] === '') {
        callback(new Error(`详细地址必填`))
      }
      if (value && value.trim().length > 50) {
        callback(new Error(`详细地址字符最大为50个字符`))
      }
      callback()
    }
  },
  computed: {
    cityList () {
      return this.addressData.find(el => el.name === this.editRunServiceData.province) ? this.addressData.find(el => el.name === this.editRunServiceData.province).city : []
    },
    areaList () {
      return this.cityList.find(el => el.name === this.editRunServiceData.city) ? this.cityList.find(el => el.name === this.editRunServiceData.city).area : []
    }
  },
  watch: {
    'initCount.value' (val) {
      if (val > 0) {
        this.$set(this, 'editRunServiceData', {
          province: '',
          city: '',
          area: '',
          detailAddress: ''
        })
      }
    },
    'initState.state' (val) {
      if (val) {
        this.initData()
      }
    }
  }
}
</script>

<style lang="scss">
  $width :100px;
  .rc-address-runtime.to-left {
    position: relative;
    padding-left: $width;
    height: 28px;
    .item-name {
      display: block;
    }
    .form-item-label {
      width: $width;
      position: absolute;
      left: 0;
      top: 0;
    }
    .form-item-address {
      float: left;
      width: 25%;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
    .el-input__inner {
      padding-left: 10px;
    }
    .form-input {
      display: inline-block;
    }
    .form-select-address {
      display: inline-block;
      width: calc(100% - 14px);
    }
  }
  .rc-address-runtime {
    position: relative;
    padding-left: 0px;
    height: 65px;
    .item-name {
      display: block;
    }
    .el-form-item::after, .el-form-item::before {
      display: table;
      content: "";
    }
    .form-item-label {
      width: $width;
      position: unset;
      left: 0;
      top: 0;
      .el-form-item__label{
        text-align: left;
      }
    }
    .form-item-address {
      float: left;
      width: 25%;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
    .el-input__inner {
      padding-left: 10px;
    }
    .form-input {
      display: inline-block;
    }
    .form-select-address {
      display: inline-block;
      width: calc(100% - 14px);
    }
  }

  .rc-address-runtime.hidden {
    padding-left: 0px;
    position: relative;
    height: 28px;
    .item-name {
      display: block;
    }
    .form-item-label {
      width: $width;
      position: absolute;
      left: 0;
      top: 0;
      .el-form-item__label{
        display: none;
      }
      .el-form-item__content{
        .component-explain-tooltip{
          left: -110px !important;
        }
      }
    }
    .form-item-address {
      float: left;
      width: 25%;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
    .el-input__inner {
      padding-left: 10px;
    }
    .form-input {
      display: inline-block;
    }
    .form-select-address {
      display: inline-block;
      width: calc(100% - 14px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-address.vue